<div class="guide-group" (click)="close($event)" [ngStyle]="{'display': show ? 'flex':'none'}" #ggref id="ggref">
    <div class="gg-hh" [ngClass]="{'gg-vv': deviceMode !== 0,  'widthMode': isWidthMode}">
        <img src="/assets/imgs/guide/{{pici + (deviceMode === 0 ? '': 'vv')}}.png?time=1598953653" />
    </div>
</div>